/**
 * @description: 百度、快手批量编辑、复制时index.vue的一些通用方法
 * @return {*}
 */
export default {
  /**
   * @description: 根据id删除一个任务tab
   * @param {*} id
   */
  onTaskTabRemove(id) {
    const tasks = this.taskList.filter((task) => task.taskId !== id)

    // 当删除的为当前任务时，切换到第一个任务
    tasks[0].taskStates.filled = true
    this.currTaskId = tasks[0].taskId
    this.taskList = tasks
  },

  onTaskTabChange(id) {
    this.taskList = this.taskList.map((task) => {
      const newState = { ...task.taskStates }
      if (newState.id === id) newState.filled = true
      return {
        ...task,
        taskStates: newState
      }
    })
  },

  /**
   * @description: 当前任务校验
   * @return {*}
   */
  taskFormValidator() {
    const refs = this.$refs
    const validList = []
    for (const ref in refs) {
      // formPrefix: baidu | kuaishou | ada | gdt-v3-form
      if (ref.startsWith(`${this.formPrefix}-`)) {
        validList.push(refs[ref].formValidate())
      }
    }

    return Promise.all(validList)
  },

  /**
   * @description: tab切换前进行表单校验
   * @return: 返回promise.resolve() 切换到下一个tab
   */
  async doCurrentFormValidate() {
    try {
      const validations = await this.taskFormValidator()
      return Promise.resolve()
    } catch (e) {
      const errorElement = document.querySelector('.el-form-item__error')
      errorElement?.scrollIntoView({ block: 'center', behavior: 'smooth' })
      console.log('eeeeeee output: ', e)
      return Promise.reject(e)
    }
  },

  /**
   * @description: 取消批量修改，关闭页面
   */
  doCannel() {
    this.$confirm('确认取消编辑？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      window.close()
    })
  }
}
